var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorFirstAid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350,
    height: 201.839,
    viewBox: "0 0 350 201.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(469.41 -150.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M-250.443,150.876l-57.607.172a5.126,5.126,0,0,0-5.111,5.142l.044,14.646a5.126,5.126,0,0,0,5.141,5.111l57.608-.173a5.128,5.128,0,0,0,5.111-5.142l-.044-14.646A5.126,5.126,0,0,0-250.443,150.876Zm-8.012,17.422a2.721,2.721,0,0,1-2.713,2.729l-36.036.109a2.723,2.723,0,0,1-2.73-2.713l-.018-6.037a2.722,2.722,0,0,1,2.713-2.73l36.036-.108a2.722,2.722,0,0,1,2.73,2.713Z",
    fill: "#23cccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M-193.431,303.466l-170.556.512a11.051,11.051,0,0,1-11.084-11.018l-.339-112.8a11.052,11.052,0,0,1,11.019-11.084l170.556-.512a11.052,11.052,0,0,1,11.084,11.019l.339,112.8A11.052,11.052,0,0,1-193.431,303.466Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_143",
    "data-name": "Line 143",
    y1: 0.149,
    x2: 90.33,
    transform: "translate(-337.943 173.256)",
    fill: "none",
    stroke: "#fcffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.518
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M-369.1,183.827a10.328,10.328,0,0,1,10.3-10.359l11.021-.033",
    fill: "none",
    stroke: "#fcffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.518
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M-192.432,274.428l-172.727.518a9.967,9.967,0,0,1-10-9.936l.012,3.829a9.965,9.965,0,0,0,9.995,9.936l172.728-.519a9.964,9.964,0,0,0,9.935-10l-.011-3.829A9.967,9.967,0,0,1-192.432,274.428Z",
    fill: "#0e297f",
    opacity: 0.471
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M-249.619,216.36l-17.982.054-.054-17.982-18.839.056.054,17.982-17.982.054.056,18.839,17.982-.054.054,17.982,18.839-.057-.054-17.982,17.982-.054Z",
    fill: "#ea4e4e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 7.318,
    height: 134.908,
    rx: 1.531,
    transform: "translate(-346.409 169.553) rotate(-0.172)",
    fill: "#66a1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 7.318,
    height: 134.908,
    rx: 1.531,
    transform: "translate(-220.119 168.419) rotate(-0.172)",
    fill: "#66a1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 350,
    height: 97,
    transform: "translate(-469.41 255.715)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFirstAid);
export default __webpack_public_path__ + "static/media/error_first_aid.ff423908bd20dc9cf8ca722f027a7f36.svg";
export { ForwardRef as ReactComponent };